import React, { useEffect } from "react";
import useReveal from "../hooks/useReveal";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Welcome from "../components/Welcome";
import Gallery from "../components/Gallery";
import ProblemsQuote from "../components/ProblemsQuote";
import Services from "../components/Services";
import Testimonials from "../components/Testimonials";
import Footer from "../components/Footer";
import StickyBar from "../components/StickyBar";

const Home = () => {
  useReveal();
  useEffect(() => {
    if (window.location.hash) {
      const el = document.querySelector(window.location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 400);
    }
  }, []);
  return (
    <div className="bg-white pb-12 md:pb-0">
      <Header />
      <Hero />
      <Welcome />
      <Gallery />
      <ProblemsQuote />
      <Services />
      <Testimonials />
      <Footer />
      <StickyBar />
    </div>
  );
};

export default Home;
